<template >
  <div class="live-tv-block" v-if="dataValue.length > 0"  style="position: sticky; top: -45px;  z-index: 9;  background: rgb(255, 255, 255);
    padding-bottom: 5px; box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.22);">
    <h2 v-if="dataValue.length > 0">{{$t('liveTv')}}</h2>
    <ul v-if="dataValue.length > 0">
      <li
        class="live"
        v-for="(show,index) in dataValue"
        :key="index"
        v-on="setTimeOutData(show,index)"
        @click="openLiveShow(show.languageCode,show)"
        v-if="show.isActive"
      >
        <div class="live-tv-user">
          <img :src="show.hostPicture" alt />
        </div>
        <p>{{show.langName}}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import ImageSpinner from "../Common/ImageSpinner";
import VueCookie from "vue-cookie";
export default {
  name: "LiveHost",
  components: { ImageSpinner },
  props: {
    liveShow: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      dataValue: [],
      CurrentDate: Math.trunc(new Date().getTime() / 1000)
    };
  },
  watch: {
    liveShow() {
      if (this.liveShow) {
        this.dataValue = this.liveShow;
      }
    }
  },
  methods: {
    openLiveShow(langType, show) {
      this.$emit("openLiveShow", langType);
    },
    getLiveShow() {
      this.$emit("getLiveShow");
    },
    setTimeOutData(show, index) {
      let endTime = Number(show.liveEndTimeMilis) / 1000;
      let totalTime = endTime - this.CurrentDate;
      setTimeout(() => {
        this.dataValue[index].isActive = false;
      }, totalTime * 1000);
    }
  },
  mounted() {
    if (this.liveShow) {
      this.dataValue = this.liveShow;
    }
    this.getLiveShow();
  }
};
</script>
